module.exports = __webpack_public_path__ + "static/media/monumnet_logo.9f2226b1.svg";